import React from "react";
import { Tabs, Typography } from "antd";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { StyledTabs, StyledParagraph, StyledCollapse, StyledPanel } from "./style";

const { TabPane } = Tabs;
const { Title } = Typography;

const FAQcollapse = () => {
  const { currentUser } = useLoginContext();
  const isCompany = isCompanyUser(currentUser);

  return (
    <StyledTabs defaultActiveKey={isCompany ? "2" : "1"}>
      <TabPane tab={<Title level={5}>For studenter</Title>} key="1">
        <StyledCollapse accordion bordered={false}>
          <StyledPanel header="Når åpner påmelding for arrangementer?" key="1">
            <StyledParagraph>
              Påmelding til arrangementene åpner klokken 12.00, 5 dager før arrangementsdagen om ikke annet er opplyst i
              arrangementsbeskrivelsen.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Når er fristen for å melde seg av et arrangement?" key="2">
            <StyledParagraph>Avmelding stenger 24 timer før arrangementet begynner.</StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hva er regler for utestengelse og prikker?" key="3">
            <StyledParagraph>
              Om du ikke møter opp på ett arrangement får du én prikk. Denne prikken er gyldig i 180 dager, og blir da
              fjernet automatisk. Hvis du får to prikker blir du utestengt fra de ti neste arrangemententene, uavhengig
              av semester. Dette betyr at en utestengelse på slutten av høstsemesteret vil medføre at du går glipp av de
              10 første arrangementene neste semester. Mer detaljert informasjon finner du i våre brukervilkår.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Jeg har fått en prikk jeg mener jeg ikke fortjener, hvordan går jeg fram?" key="4">
            <StyledParagraph>
              Send en mail til <a href="mailto:kontakt@bindeleddet.no">kontakt@bindeleddet.no</a>
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Jeg ønsker å endre linjen på min profil hos dere, hvordan går jeg fram?" key="5">
            <StyledParagraph>
              Linjen på din brukerprofil hos oss samsvarer med linjen du er registrert på hos NTNU. Om du mener dette er
              feil sender du en mail til <a href="mailto:kontakt@bindeleddet.no">kontakt@bindeleddet.no</a>
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvordan handler Bindeleddet med tanke på personvern?" key="6">
            <StyledParagraph>
              Bindeleddet lagrer nødvendige personlige opplysninger om navn, stud-mail, telefonnummer, studieretning og
              årstrinn, men deler ikke denne informasjonen med noen tredjepart. Bedriftene som arrangerer
              bedriftspresentasjon gjennom oss mottar statistikk på hvor mange studenter som har deltatt på
              arrangementet fra ulike studieretninger.
            </StyledParagraph>
          </StyledPanel>
        </StyledCollapse>
      </TabPane>

      <TabPane tab={<Title level={5}>For bedrifter</Title>} key="2">
        <StyledCollapse accordion bordered={false} style={{ backgroundColor: "white" }}>
          <StyledPanel header="Hvordan kan vi opprette stillingsannonser på sidene deres?" key="1">
            <StyledParagraph>
              Dere kan helt gratis opprette en stillingsannonse ved å gå inn på &quot;Min side&quot; øverst i høyre
              hjørne, og deretter trykke &quot;Opprett stillingsannonse&quot;. Merk at dere må være registrert som en
              bedrift for å opprette en annonse.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hva koster en bedriftspresentasjon med Bindeleddet?" key="2">
            <StyledParagraph>
              Bindeleddets prismodell består tre ulike pristrinn, differensiert på tidspunkt i sesongen. Logg inn på
              deres bedriftsbruker og gå til bookingssiden for en detaljert beskrivelse av nåværende prismodell.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Når åpner påmeldingen for bedriftspresentasjoner?" key="3">
            <StyledParagraph>
              Påmelding til bedriftspresentasjon åpner normalt i mars/april for høstsemesteret, og i oktober/november
              for vårsemesteret. Send en mail til <a href="mailto:bedrift@bindeleddet.no"> bedrift@bindeleddet.no</a>{" "}
              dersom dere ønsker å bli varslet på mail i forkant av booking-åpning!
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvilke markedsføringsalternativer tilbyr dere?" key="4">
            <StyledParagraph>
              I forbindelse med bedriftspresentasjon tilbyr vi markedsføring mot studenter i form av Instagram-stories
              både i forkant av påmelding og på selve arrangementsdagen. I tillegg henger vi opp plakater rundt på
              campus. Hver uke publiseres ukens arrangementer både på LinkedIn og Facebook. Når dere holder
              bedriftspresentasjon gjennom Bindeleddet har dere også mulighet til å stå på stand på campus på dagtid for
              å promotere dere for studenter. Utenom bedriftspresentasjon kan dere benytte dere av Bindeleddets tilbud
              om lørdagsstories.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvordan kan vi få lagt ut lørdagsstories på deres instagram?" key="5">
            <StyledParagraph>
              Send oss en henvendelse på <a href="mailto:kontakt@bindeleddet.no"> kontakt@bindeleddet.no</a> så skal vi
              hjelpe dere med dette! Tilbudet er gratis og for alle bedrifter.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvilke andre relevante arrangementer tilbyr Bindeleddet?" key="6">
            <StyledParagraph>
              <b>KarriereDagene</b> finner sted hvert år i september. Dette er Norges største Karrieremesse, der
              bedrifter står på stand på campus og får møte tusenvis av studenter fra NTNU. Hvis deres bedrift er
              interresert i å delta på KD, kan dere ta kontakt med
              <a href="mailto:kd@bindeleddet.no"> kd@bindeleddet.no</a> eller lese mer om arrangementet på{" "}
              <a href="https://www.kdntnu.no" target="_blank" rel="noreferrer">
                kdntnu.no
              </a>
              .
              <br />
              <br />
              <b>Osloturen</b> er en årlig tur til hovedstaden med mål om å gi bedre innsikt i arbeidshverdagen hos
              ulike bedrifter. 150 studenter fra Industriell økonomi og teknologiledelse reiser til Oslo for å møte
              bedriftene de er interessert i på deres kontorer. Bedriftene kan gjennomføre et eget opplegg for
              studentene og vise frem arbeidsplassen.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel
            header="Kan vi velge fritt hvilke linjer og klassetrinn som plassene på bedriftspresentasjonen skal være forbeholdt? "
            key="7"
          >
            <StyledParagraph>
              Dere kan velge så mange linjer og klassetrinn dere ønsker! Her kan dere også tilpasse etter ønsket
              prosentfordeling. Merk at det er et krav om at minst 50% av plassene er åpne for Indøk-studenter ettersom
              Bindeleddet hovedsakelig er bedriftskontakten til Industriell økonomi og teknologiledelse, men vi åpner
              gjerne for flere!
            </StyledParagraph>
          </StyledPanel>
        </StyledCollapse>
      </TabPane>
    </StyledTabs>
  );
};

export default FAQcollapse;
